import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import CaseStudies from "@/pages/CaseStudies";
import Contact from "@/pages/Contact";
import MechanismsIndex from "@/pages/MechanismsIndex";
import MechanismDetail from "@/pages/MechanismDetail";
import Products from "@/pages/Products";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import Terms from "@/pages/Terms";
import ThankYou from "@/pages/ThankYou";
import Quote from "@/pages/Quote";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Standalone landing page (no site header/footer) for paid traffic */}
        <Route path="/quote" element={<Quote />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/mechanisms" element={<MechanismsIndex />} />
          <Route path="/mechanisms/:slug" element={<MechanismDetail />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/products" element={<Products />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/thank-you" element={<ThankYou />} />
        </Route>
      </Routes>
      <Toaster position="top-right" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
